//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.1.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";

import {
  API_BASE_URL,
  FlatPermissionDto,
  PermissionDtoListResultDto,
} from "./service-proxies";

@Injectable()
export class TicketServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

   /**
     * @param fileId (optional)
     * @return Success
     */
    downloadAnswerFile(fileId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ticket/DownloadAnswerFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAnswerFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAnswerFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadAnswerFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

  deleteAnswer(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/DeleteAnswer?";
    if (id === null)
      throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteAnswer(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteAnswer(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processDeleteAnswer(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  SendCustomerTicket(
    body: CreateCustomerTicketDto | undefined
  ): Observable<CreateTicketResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/CreateCustomerTicket";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TicketDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TicketDto>;
        })
      );
  }

  SendUserTicket(
    body: CreateUserTicketDto | undefined
  ): Observable<CreateTicketResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/CreateUserTicket";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CreateTicketResultDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<CreateTicketResultDto>;
        })
      );
  }

  protected processCreate(
    response: HttpResponseBase
  ): Observable<CreateTicketResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CreateTicketResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  SendTicketAnswer(
    body: TicketAnswerDto | undefined
  ): Observable<TicketAnswerDto> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/SendAnswer";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendAnswer(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendAnswer(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TicketAnswerDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TicketAnswerDto>;
        })
      );
  }

  protected processSendAnswer(
    response: HttpResponseBase
  ): Observable<TicketAnswerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TicketAnswerDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  editTicketAnswer(
    body: TicketAnswerDto | undefined
  ): Observable<TicketAnswerDto> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/UpdateAnswer";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEditAnswer(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEditAnswer(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TicketAnswerDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TicketAnswerDto>;
        })
      );
  }

  protected processEditAnswer(
    response: HttpResponseBase
  ): Observable<TicketAnswerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TicketAnswerDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  getTicketDetials(id: number | undefined): Observable<TicketDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/GetTicketDetails?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TicketDetailsDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TicketDetailsDto>;
        })
      );
  }

  protected processGetDetails(
    response: HttpResponseBase
  ): Observable<TicketDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TicketDetailsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  CheckNewTicket(): Observable<TicketAnswerDto[]> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/CheckNewTickets?";

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckNewTicket(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckNewTicket(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TicketAnswerDto[]>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TicketAnswerDto[]>;
        })
      );
  }

  protected processCheckNewTicket(
    response: HttpResponseBase
  ): Observable<TicketAnswerDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          return _observableOf(resultData200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  getUserUnreadCount(type: number): Observable<number> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/GetUserUnreadCount?";
    if (type === null) throw new Error("The parameter 'id' cannot be null.");
    else if (type !== undefined)
      url_ += "Type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.ProccessGetUserUnreadCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.ProccessGetUserUnreadCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<number>;
        })
      );
  }

  protected ProccessGetUserUnreadCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = parseInt(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  getTicketFile(
    fileId: number | undefined,
    ticketId: number | undefined
  ): Observable<TicketFileModel> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/GetTicketFile?";
    if (fileId === null)
      throw new Error("The parameter 'FileId' cannot be null.");
    else if (fileId !== undefined)
      url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";

    if (ticketId === null)
      throw new Error("The parameter 'ticketId' cannot be null.");
    else if (ticketId !== undefined)
      url_ += "TicketId=" + encodeURIComponent("" + ticketId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTicketFile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTicketFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TicketFileModel>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TicketFileModel>;
        })
      );
  }

  protected processGetTicketFile(
    response: HttpResponseBase
  ): Observable<TicketFileModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TicketFileModel.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @param id (optional)
   * @return Success
   */

  changeTicketStatus(id: number | undefined, newStatusCode: number): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/ticket/ChangeTicketStatus?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "TicketId=" + encodeURIComponent("" + id) + "&";
    if (newStatusCode === null) throw new Error("The parameter 'newStatusCode' cannot be null.");
    else if (newStatusCode !== undefined)
      url_ += "NewStatusCode=" + encodeURIComponent("" + newStatusCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeTicketStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeTicketStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processChangeTicketStatus(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param keyword (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllSentTickets(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<TicketDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/getAllSentTickets?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<TicketDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TicketDtoPagedResultDto>;
        })
      );
  }

  getAllReceivedTicketsForUser(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<TicketDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Ticket/getAllReceivedTicketsForUser?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<TicketDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TicketDtoPagedResultDto>;
        })
      );
  }

  protected processGetAll(
    response: HttpResponseBase
  ): Observable<TicketDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TicketDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
  getAllTicketsForUser(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<TicketDtoPagedResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Ticket/getAllTicketsForUser?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<TicketDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TicketDtoPagedResultDto>;
        })
      );
  }

  protected processGetAllAnswers(
    response: HttpResponseBase
  ): Observable<TicketAnswerDtoPagedResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TicketAnswerDtoPagedResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
  getTicketAnswersForUser(
    keyword: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    ticketId: number
  ): Observable<TicketAnswerDtoPagedResultDto> {
    let url_ =
      this.baseUrl + "/api/services/app/Ticket/getTicketAnswersForUser?";
    if (keyword === null)
      throw new Error("The parameter 'keyword' cannot be null.");
    else if (keyword !== undefined)
      url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
    if (skipCount === null)
      throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
    if (maxResultCount === null)
      throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
    if (ticketId === null) {
      throw new Error("The parameter 'ticketId' cannot be null.");
    } else if (ticketId !== undefined) {
      url_ += "TicketId=" + encodeURIComponent("" + ticketId) + "&";
    }
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllAnswers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllAnswers(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<TicketAnswerDtoPagedResultDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TicketAnswerDtoPagedResultDto>;
        })
      );
  }

  protected processGetAnswerFiles(
    response: HttpResponseBase
  ): Observable<TicketAnswerFileDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
  getAnswerFiles(
    answerId: number
  ): Observable<TicketAnswerFileDto[]> {
    let url_ =
      this.baseUrl + "/api/services/app/Ticket/getAnswerFiles?";
    if (answerId === null) {
      throw new Error("The parameter 'ticketId' cannot be null.");
    } else if (answerId !== undefined) {
      url_ += "AnswerId=" + encodeURIComponent("" + answerId) + "&";
    }
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "text/plain",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAnswerFiles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAnswerFiles(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<TicketAnswerFileDto[]>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<TicketAnswerFileDto[]>;
        })
      );
  }
}

export class CreateCustomerTicketDto implements ICreateCustomerTicketDto {
  title: string;
  description: string | undefined;
  subjectId: number;
  attachements: TicketFileModel[] = [];

  constructor(data?: ICreateCustomerTicketDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
      this.subjectId = _data["subjectId"];
      this.description = _data["description"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
    }
  }

  static fromJS(data: any): CreateCustomerTicketDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateCustomerTicketDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    data["subjectId"] = this.subjectId;
    data["description"] = this.description;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }
    return data;
  }

  clone(): CreateCustomerTicketDto {
    const json = this.toJSON();
    let result = new CreateCustomerTicketDto();
    result.init(json);
    return result;
  }
}

export interface ICreateCustomerTicketDto {
  title: string;
  description: string;
  subjectId: number;
  attachements: TicketFileModel[];
}

export class CreateUserTicketDto implements ICreateUserTicketDto {
  title: string;
  description: string | undefined;
  isPublic: boolean;
  actionRequired: boolean;
  mayContainAnswer: boolean;
  receiverUserIds: number[];
  priorityDegree: number;
  hasFileRequest: boolean;
  attachements: TicketFileModel[] = [];
  subjectId: number;

  constructor(data?: ICreateCustomerTicketDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
      this.description = _data["description"];
      this.isPublic = _data["isPublic"];
      this.actionRequired = _data["actionRequired"];
      this.priorityDegree = _data["priorityDegree"];
      this.mayContainAnswer = _data["mayContainAnswer"];
      this.subjectId = _data["subjectId"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
      if (Array.isArray(_data["receiverUserIds"])) {
        this.receiverUserIds = [] as any;
        for (let item of _data["receiverUserIds"]) this.receiverUserIds.push(item);
      }
    }
  }

  static fromJS(data: any): CreateCustomerTicketDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateCustomerTicketDto();
    result.init(data);

    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    data["description"] = this.description;
    data["isPublic"] = this.isPublic;
    data["actionRequired"] = this.actionRequired;
    data["priorityDegree"] = this.priorityDegree;
    data["mayContainAnswer"] = this.mayContainAnswer;
    data["subjectId"] = this.subjectId;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }
    if (Array.isArray(this.receiverUserIds)) {
      data["receiverUserIds"] = [];
      for (let item of this.receiverUserIds) data["receiverUserIds"].push(item);
    }
    return data;
  }

  clone(): CreateCustomerTicketDto {
    const json = this.toJSON();
    let result = new CreateCustomerTicketDto();
    result.init(json);
    return result;
  }
}

export interface ICreateUserTicketDto {
  title: string;
  description: string;
  isPublic: boolean;
  actionRequired: boolean;
  mayContainAnswer: boolean;
  receiverUserIds: number[];
  priorityDegree: number;
  attachements: TicketFileModel[];
  subjectId: number;
}

export class TicketFileModel implements ITicketFileModel {
  fileBase64: string | ArrayBuffer;
  fileName: string;
  contentType: string;
  thumbnail: string;
  id: number;
  file: File;
  constructor(data?: ITicketFileModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileBase64 = _data["fileBase64"];
      this.fileName = _data["fileName"];
      this.contentType = _data["contentType"];
      this.thumbnail = _data["thumbnail"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TicketFileModel {
    data = typeof data === "object" ? data : {};
    let result = new TicketFileModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["fileBase64"] = this.fileBase64;
    data["fileName"] = this.fileName;
    data["contentType"] = this.contentType;
    data["thumbnail"] = this.thumbnail;
    data["id"] = this.id;
    return data;
  }

  clone(): TicketFileModel {
    const json = this.toJSON();
    let result = new TicketFileModel();
    result.init(json);
    return result;
  }
}

export interface ITicketFileModel {
  fileBase64: string | ArrayBuffer;
  fileName: string;
  contentType: string;
  thumbnail: string;
  id: number;
  file: File;
}

export class TicketDto implements ITicketDto {
  id: number;
  title: string;
  description: string;
  senderUserName: string;
  receiverUserName: string;
  priorityDegree: number;
  statusName: string;
  statusCode: number;
  subjectName: string;
  seen: boolean;
  actionRequired: boolean;
  mayContainAnswer: boolean;
  isUserTicket: boolean;
  newAnswersCount: number;
  destUserId: number;
  subjectId: number;
  userImage: string;
  thumbnail: string;
  lastAnswerDate: string;

  constructor(data?: ITicketDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      this.description = _data["description"];
      this.senderUserName = _data["senderUserName"];
      this.receiverUserName = _data["receiverUserName"];
      this.priorityDegree = _data["priorityDegree"];
      this.statusName = _data["statusName"];
      this.statusCode = _data["statusCode"];
      this.seen = _data["seen"];
      this.actionRequired = _data["actionRequired"];
      this.mayContainAnswer = _data["mayContainAnswer"];
      this.isUserTicket = _data["isUserTicket"];
      this.newAnswersCount = _data["newAnswersCount"];
      this.userImage = _data["userImage"];
      this.destUserId = _data["destUserId"];
      this.subjectId = _data["subjectId"];
      this.subjectName = _data["subjectName"];
      this.thumbnail = _data["thumbnail"];
      this.lastAnswerDate = _data["lastAnswerDate"];
    }
  }

  static fromJS(data: any): TicketDto {
    data = typeof data === "object" ? data : {};
    let result = new TicketDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    data["description"] = this.description;
    data["senderUserName"] = this.senderUserName;
    data["receiverUserName"] = this.receiverUserName;
    data["priorityDegree"] = this.priorityDegree;
    data["statusName"] = this.statusName;
    data["statusCode"] = this.statusCode;
    data["seen"] = this.seen;
    data["actionRequired"] = this.actionRequired;
    data["mayContainAnswer"] = this.mayContainAnswer;
    data["isUserTicket"] = this.isUserTicket;
    data["newAnswersCount"] = this.newAnswersCount;
    data["userImage"] = this.userImage;
    data["destUserId"] = this.destUserId;
    data["subjectId"] = this.subjectId;
    data["subjectName"] = this.subjectName;
    data["thumbnail"] = this.thumbnail;
    data["lastAnswerDate"] = this.lastAnswerDate;
    return data;
  }

  clone(): TicketDto {
    const json = this.toJSON();
    let result = new TicketDto();
    result.init(json);
    return result;
  }
}

export interface ITicketDto {
  id: number;
  title: string;
  description: string;
  senderUserName: string;
  receiverUserName: string;
  priorityDegree: number;
  statusName: string;
  statusCode: number;
  seen: boolean;
  actionRequired: boolean;
  mayContainAnswer: boolean;
  isUserTicket: boolean;
  newAnswersCount: number;
  destUserId: number;
  subjectId: number;
  userImage: string;
  subjectName: string;
  thumbnail: string;
  lastAnswerDate: string;
}

export class TicketAnswerDto implements ITicketAnswerDto {
  id: number;
  description: string;
  answerUserName: string;
  answerUserId: number;
  priorityDegree: number;
  seen: boolean;
  seenDate: string;
  actionRequired: boolean;
  isUserTicket: boolean;
  seenByUserThisTime: boolean;
  filesCount: number;
  ticketId: number;
  attachements: TicketFileModel[];
  replyToAnswerId: number;
  replyToAnswerText: string;
  sendDate: string;

  constructor(data?: ITicketAnswerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.description = _data["description"];
      this.answerUserName = _data["answerUserName"];
      this.answerUserId = _data["answerUserId"];
      this.priorityDegree = _data["priorityDegree"];
      this.seen = _data["seen"];
      this.seenDate = _data["seenDate"];
      this.actionRequired = _data["actionRequired"];
      this.filesCount = _data["filesCount"];
      this.seenByUserThisTime = _data["seenByUserThisTime"];
      this.ticketId = _data["ticketId"];
      this.isUserTicket = _data["isUserTicket"];
      this.replyToAnswerId = _data["replyToAnswerId"];
      this.replyToAnswerText = _data["replyToAnswerText"];
      this.sendDate = _data["sendDate"];
      if (Array.isArray(_data["attachements"])) {
        this.attachements = [] as any;
        for (let item of _data["attachements"]) this.attachements.push(item);
      }
    }
  }

  static fromJS(data: any): TicketAnswerDto {
    data = typeof data === "object" ? data : {};
    let result = new TicketAnswerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["description"] = this.description;
    data["answerUserName"] = this.answerUserName;
    data["answerUserId"] = this.answerUserId;
    data["priorityDegree"] = this.priorityDegree;
    data["seen"] = this.seen;
    data["seenDate"] = this.seenDate;
    data["actionRequired"] = this.actionRequired;
    data["seenByUserThisTime"] = this.seenByUserThisTime;
    data["filesCount"] = this.filesCount;
    data["isUserTicket"] = this.isUserTicket;
    data["ticketId"] = this.ticketId;
    data["replyToAnswerId"] = this.replyToAnswerId;
    data["replyToAnswerText"] = this.replyToAnswerText;
    data["sendDate"] = this.sendDate;
    if (Array.isArray(this.attachements)) {
      data["attachements"] = [];
      for (let item of this.attachements) data["attachements"].push(item);
    }
    return data;
  }

  clone(): TicketAnswerDto {
    const json = this.toJSON();
    let result = new TicketAnswerDto();
    result.init(json);
    return result;
  }
}

export interface ITicketAnswerDto {
  id: number;
  description: string;
  answerUserName: string;
  answerUserId: number;
  priorityDegree: number;
  seen: boolean;
  seenDate: string;
  actionRequired: boolean;
  seenByUserThisTime: boolean;
  isUserTicket: boolean;
  filesCount: number;
  ticketId: number;
  replyToAnswerId: number;
  replyToAnswerText: string;
  sendDate: string;
  attachements: TicketFileModel[];
}

export class TicketDetailsDto implements ITicketDetailsDto {
  id: number;
  title: string;
  description: string;
  senderUserName: string;
  receiverUserName: string;
  priorityDegree: number;
  statusName: string;
  actionRequired: boolean;
  mayContainAnswer: boolean;
  attachementIds: number[];
  seenByReceiver: boolean;
  isPublic: boolean;

  constructor(data?: ITicketDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      this.description = _data["description"];
      this.senderUserName = _data["senderUserName"];
      this.receiverUserName = _data["receiverUserName"];
      this.priorityDegree = _data["priorityDegree"];
      this.statusName = _data["statusName"];
      this.seenByReceiver = _data["seenByReceiver"];
      this.actionRequired = _data["actionRequired"];
      this.mayContainAnswer = _data["mayContainAnswer"];
      this.isPublic = _data["isPublic"];
      if (Array.isArray(_data["attachementIds"])) {
        this.attachementIds = [] as any;
        for (let item of _data["attachementIds"])
          this.attachementIds.push(item);
      }
    }
  }

  static fromJS(data: any): TicketDetailsDto {
    data = typeof data === "object" ? data : {};
    let result = new TicketDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    data["description"] = this.description;
    data["senderUserName"] = this.senderUserName;
    data["receiverUserName"] = this.receiverUserName;
    data["priorityDegree"] = this.priorityDegree;
    data["statusName"] = this.statusName;
    data["seenByReceiver"] = this.seenByReceiver;
    data["actionRequired"] = this.actionRequired;
    data["mayContainAnswer"] = this.mayContainAnswer;
    data["isPublic"] = this.isPublic;
    if (Array.isArray(this.attachementIds)) {
      data["attachementIds"] = [];
      for (let item of this.attachementIds) data["attachementIds"].push(item);
    }
    return data;
  }

  clone(): TicketDto {
    const json = this.toJSON();
    let result = new TicketDto();
    result.init(json);
    return result;
  }
}

export interface ITicketDetailsDto {
  id: number;
  title: string;
  description: string;
  senderUserName: string;
  receiverUserName: string;
  priorityDegree: number;
  statusName: string;
  actionRequired: boolean;
  mayContainAnswer: boolean;
  attachementIds: number[];
  seenByReceiver: boolean;
  isPublic: boolean;
}

export class CreateTicketResultDto implements ICreateTicketResultDto {
  id: number;

  constructor(data?: CreateTicketResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CreateTicketResultDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateTicketResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;

    return data;
  }

  clone(): CreateTicketResultDto {
    const json = this.toJSON();
    let result = new CreateTicketResultDto();
    result.init(json);
    return result;
  }
}

export interface ICreateTicketResultDto {
  id: number;
}

export class TicketDtoPagedResultDto implements ITicketDtoPagedResultDto {
  items: TicketDto[] | undefined;
  totalCount: number;

  constructor(data?: ITicketDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(TicketDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): TicketDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new TicketDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): TicketDtoPagedResultDto {
    const json = this.toJSON();
    let result = new TicketDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ITicketDtoPagedResultDto {
  items: TicketDto[] | undefined;
  totalCount: number;
}

export class TicketAnswerFileDto implements ITicketAnswerFileDto {
  id: number;
  answerId: number;
  answerFile: TicketFileModel;

  constructor(data?: ITicketAnswerFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["Id"];
      this.answerId = _data["answerId"];
      this.answerFile = _data["answerFile"];
    }
  }

  static fromJS(data: any): TicketAnswerFileDto {
    data = typeof data === "object" ? data : {};
    let result = new TicketAnswerFileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["Id"] = this.id;
    data["answerFile"] = this.answerFile;
    data["answerId"] = this.answerId;
    return data;
  }

  clone(): TicketAnswerFileDto {
    const json = this.toJSON();
    let result = new TicketAnswerFileDto();
    result.init(json);
    return result;
  }
}

export interface ITicketAnswerFileDto {
  id: number;
  answerId: number;
  answerFile: TicketFileModel;
}

export class TicketAnswerDtoPagedResultDto
  implements ITicketAnswerDtoPagedResultDto {
  items: TicketAnswerDto[] | undefined;
  totalCount: number;

  constructor(data?: ITicketAnswerDtoPagedResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(TicketAnswerDto.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): TicketAnswerDtoPagedResultDto {
    data = typeof data === "object" ? data : {};
    let result = new TicketAnswerDtoPagedResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["totalCount"] = this.totalCount;
    return data;
  }

  clone(): TicketAnswerDtoPagedResultDto {
    const json = this.toJSON();
    let result = new TicketAnswerDtoPagedResultDto();
    result.init(json);
    return result;
  }
}

export interface ITicketAnswerDtoPagedResultDto {
  items: TicketAnswerDto[] | undefined;
  totalCount: number;
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new ApiException(message, status, response, headers, null)
    );
}
